import { Locale } from '@front/i18n';

import { Country, Currency } from '../types/commons';

export const COUNTRIES: Record<Country, Country> = {
  FR: 'FR',
  GB: 'GB',
};

export const SUPPORTED_COUNTRIES = Object.values(COUNTRIES);

export const DEFAULT_COUNTRY = COUNTRIES.FR;

export const COUNTRIES_BY_DOMAIN: Record<string, Country> = {
  '.co.uk': COUNTRIES.GB,
  '.fr': COUNTRIES.FR,
};

export const LOCALES_BY_COUNTRY: Record<Country, Locale> = {
  FR: 'fr',
  GB: 'en',
};

export const CURRENCIES_BY_COUNTRY: Record<Country, Currency> = {
  FR: 'EUR',
  GB: 'GBP',
};

export const TIMEZONES_BY_COUNTRY = {
  [COUNTRIES.FR]: 'Europe/Paris',
  [COUNTRIES.GB]: 'Europe/London',
};

export const DOMAINS_BY_COUNTRY = {
  [COUNTRIES.FR]: '.fr',
  [COUNTRIES.GB]: '.co.uk',
};

export const SUPPORTED_PHONE_NUMBER_COUNTRIES = ['gb', 'fr', 'be', 'ch'];
